import { nf } from "@/lib/format";
import { L } from "@/i18n";
import { Panel } from "./Panel";

export const ModuleBreakdown = ({ modules }) => {
  const max = Math.max(1, ...modules.map((m) => m.count));
  return (
    <Panel testId="module-breakdown" title={L("Catalog by module", "Catálogo por módulo")} subtitle={L("Questions and submodules in each Part-66 module", "Perguntas e submódulos em cada módulo Part-66")}>
      <ul className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-4">
        {modules.map((m) => (
          <li key={m.id} data-testid={`module-breakdown-${m.id}`}>
            <div className="flex items-baseline justify-between gap-3 text-xs mb-1.5">
              <span className="min-w-0 truncate">
                <b className="font-mono text-amber-400 mr-2">{m.id}</b>
                <span className="text-slate-300">{m.name}</span>
              </span>
              <span className="shrink-0 font-mono text-slate-400">
                {nf.format(m.count)} <span className="text-slate-600">· {m.submodules} sub</span>
              </span>
            </div>
            <div className="h-1 rounded-full bg-slate-800 overflow-hidden">
              <div className="h-full bg-amber-500/80 rounded-full" style={{ width: `${(m.count / max) * 100}%` }} />
            </div>
          </li>
        ))}
      </ul>
    </Panel>
  );
};
